const styles = {
  calendarHeaderBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  calendarMonthLabel: {
    flexGrow: 1,
    textAlign: 'center',
    fontWeight: 600,
  },
};

export default styles;
